import { Button, Col, Container, ListGroup, Row, Stack } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import classes from "./styles.module.scss";
import { useLink } from "@/hooks/useLink";
import clsx from "classnames";
import SocialShare from "@/ui/SocialShare";
import { JobPageApplySection } from "@/components/JobPage";

export const JobPageContentSection = ({ className, id, description, similar }) => {
  const locale = useLocale();
  const link = useLink();

  return (
    <div className={clsx(className, "px-md-5")}>
      <Container>
        <Row>
          <Col xs={12} md={7}>
            <div className="d-md-none mb-4">
              <SocialShare className={classes.logo} />
            </div>
            <div dangerouslySetInnerHTML={{ __html: description }} className="mb-5" />
            <JobPageApplySection id={id} />
          </Col>
          <Col xs={12} md={5}>
            <div className="d-none d-md-block mb-4">
              <SocialShare className={classes.logo} />
            </div>
            {similar.length > 0 && (
              <aside className={classes.similar}>
                <DynamicText path={`page.job.similar.title.${locale}`} tag="h5" className="mb-4" />
                <ListGroup>
                  {similar.map((i) => (
                    <ListGroup.Item key={i.id} className="px-0">
                      <Stack className="flex-sm-row">
                        <div className="flex-grow-1">
                          <a href={link(`jobs.item`, i.url_slug)}>
                            <div className="h5" dangerouslySetInnerHTML={{ __html: i.title }} />
                            <dl className="mb-0">
                              <dt>
                                <DynamicText path={`page.job.details.location.${locale}`} />
                              </dt>
                              <dd dangerouslySetInnerHTML={{ __html: i.location }} />
                            </dl>
                            <dl className="mb-0">
                              <dt>
                                <DynamicText path={`page.job.details.salary.${locale}`} />
                              </dt>
                              <dd dangerouslySetInnerHTML={{ __html: i.salary_package }} />
                            </dl>
                          </a>
                        </div>
                        <div className="flex-shrink-0">
                          <Button variant="outline-primary">
                            <DynamicText path={`job.card.button.${locale}`} />
                          </Button>
                        </div>
                      </Stack>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </aside>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};
